import * as React from "react";
import * as S from "@styled";
import Collapse from "@kunukn/react-collapse";
import colors from "shared/styles/colors";
import useUserTheme from "shared/styles/hooks/useUserTheme";
import { ThemeType } from "shared/styles/theme";

export const SwitchCollapse: React.FC<SwitchCollapseProps> = (props) => {
    const [theme] = useUserTheme();
    const [isOpen, setIsOpen] = React.useState<boolean>(props.isOpenByDefault || false);

    const onClick = () => {
        setIsOpen(open => !open);
    }
    return (
        <S.FormGroup $noMargin={true}>
            <S.Label style={{ color: theme === ThemeType.light ? colors.purplePrimary : colors.purpleTertiary }} className="pointer" onClick={onClick}>
                {isOpen ? FRENDS.Localizations.Hide : FRENDS.Localizations.Show} {(FRENDS.Localizations.AdvancedSettings).toLowerCase()} {isOpen ? <i className="ci-chevron_duo_up" /> : <i className="ci-chevron_duo_down" />}
            </S.Label>
            {isOpen ? (
                <Collapse
                    overflowOnExpanded={props.overflowOnExpandedOpenChildren}
                    isOpen={true}
                >
                    {props.childrenOpen}
                </Collapse>
            ) : (
                <Collapse
                    isOpen={true}
                >
                    {props.childrenCollapsed}
                </Collapse>
            )}
        </S.FormGroup>
    );
}

interface SwitchCollapseProps {
    isOpenByDefault: boolean | undefined;
    childrenCollapsed: React.ReactChild | null;
    childrenOpen: React.ReactChild;
    /**
     * Collapse container allows overflowing around open children when true
     */
    overflowOnExpandedOpenChildren?: boolean;
}

